import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.object.keys.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { useId } from '@nerdwallet/react-accessibility';
import classes from '@nerdwallet/base-styles/classes';
import { Box } from '../Box/Box';
import { Type } from '../Type/Type';
import style from './Card.module.less';

/**
 * A standard interactive container element. The element
 * is actionable and accessible, and mounts a <a> by default.
 */
export var Card = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _classNames;

  var ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      children = props.children,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'a' : _props$component,
      href = props.href,
      primary = props.primary,
      prompt = props.prompt,
      dangerouslyForceActiveStyling = props.dangerouslyForceActiveStyling,
      dangerouslyForceFocusStyling = props.dangerouslyForceFocusStyling,
      dangerouslyForceHoverStyling = props.dangerouslyForceHoverStyling,
      otherProps = _objectWithoutProperties(props, ["aria-label", "aria-labelledby", "children", "className", "component", "href", "primary", "prompt", "dangerouslyForceActiveStyling", "dangerouslyForceFocusStyling", "dangerouslyForceHoverStyling"]);

  var promptId = useId();
  return /*#__PURE__*/React.createElement(Component, _extends({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledby,
    "aria-describedby": promptId,
    className: classNames(style.card, (_classNames = {}, _defineProperty(_classNames, classes('shadow-1'), primary), _defineProperty(_classNames, style['force-active'], dangerouslyForceActiveStyling), _defineProperty(_classNames, style['force-focus'], dangerouslyForceFocusStyling), _defineProperty(_classNames, style['force-hover'], dangerouslyForceHoverStyling), _classNames), className),
    href: href,
    ref: ref
  }, otherProps), children, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(Type, {
    gotham: true,
    color: "blue",
    component: "p",
    size: 2,
    "aria-hidden": "true",
    id: promptId
  }, prompt)));
});
Card.displayName = 'Card';